import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Button,
  Paper,
  Avatar,
} from "@mui/material";

import { useSelector } from "react-redux";
import DataStatusAlert from "../../../../Health/DataAccuracy/UI_HelpersOf_DataAccuracy/DataStatusAlert_Helpers";
import dayjs from "dayjs";

interface StatusHistoryModalProps {
  open: boolean;
  onClose: () => void;
}

const StatusHistoryLog: React.FC<StatusHistoryModalProps> = ({
  open,
  onClose,
}) => {
  const { singleactionItemDetails } = useSelector(
    (state: any) => state?.actionItems
  );
  const { status_log } = singleactionItemDetails;

  const sortData =
  status_log?.length > 0 &&
  status_log
      .slice()
      .sort(
        (a: any, b: any) =>
          new Date(b.modified_at).getTime() - new Date(a.modified_at).getTime()
      );

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>Status History Log</DialogTitle>
      <DialogContent>
        <TableContainer>
          <Paper
            sx={{
              width: "100%",
              overflowY: "auto",
              height: "auto",
              maxHeight: "300px",
            }}
          >
            <Table size="small" aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ padding: "4px" }}>Status</TableCell>
                  <TableCell sx={{ padding: "4px" }}>Modified On</TableCell>
                  <TableCell sx={{ padding: "4px" }}>Modified By</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {sortData?.map((row: any, index: number) => (
                  <TableRow
                    key={index}
                    sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                  >
                    <TableCell sx={{ padding: "4px" }}>
                      <DataStatusAlert status={row.status} />
                    </TableCell>
                    <TableCell sx={{ padding: "4px" }}>
                      {row.modified_at ? dayjs(row.modified_at).format("DD/MM/YYYY") : ""}
                    </TableCell>
                    <TableCell sx={{ padding: "4px" }}>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          gap: "8px",
                        }}
                      >
                        <Avatar
                          sx={{
                            width: 22,
                            height: 22,
                            fontSize: 12,
                          }}
                        >
                          {row.modified_by.charAt(0).toUpperCase()}
                        </Avatar>
                        {row.modified_by}
                      </div>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
        </TableContainer>
        <Button
          variant="contained"
          color="secondary"
          onClick={onClose}
          sx={{ marginTop: 2, float: "right" }}
        >
          Close
        </Button>
      </DialogContent>
    </Dialog>
  );
};

export default StatusHistoryLog;
